class NotificationBanner extends HTMLElement {
  constructor() {
    super();
    this.closeButton = this.querySelector('.notification-banner__close');
    this.closeButton?.addEventListener('click', () => {
      this.hideCartValidationBanner();
    });
  }

  setCartValidationBanner(requestedQty, allowedMax, country) {
    const messageEl = this.querySelector('.alert-message span');
    if (!messageEl) return;

    const messages = window.cartQtyMessages || {};

    const template =
      country !== 'US'
        ? messages.intl
        : messages.us;

    messageEl.textContent = template?.replace('{{ max }}', allowedMax) || '';

    this.classList.add('notification-banner--visible');
  }

  hideCartValidationBanner() {
    this.classList.remove('notification-banner--visible');
  }
}

customElements.define('notification-banner', NotificationBanner);
